const NOTIFICATION = {
  TYPES: {
    ALL_WORKFLOWS_RULES_INACTIVE: 'notifyAboutRulesInactiveEnabled',
  },
};

Object.freeze(NOTIFICATION);

export default NOTIFICATION;
